import SlackLogo from 'Shared/images/slackLogo.svg';
import JiraLogo from 'Shared/images/JiraLogo.svg';
import HubspotLogo from 'Shared/images/HubspotLogo.svg';
import SalesforceLogo from 'Shared/images/salesforce-logo.svg';
import AsanaLogo from 'Shared/images/AsanaLogo.svg';

import { InputDataSourceItemType } from './types';

import { IntegrationSources } from 'Shared/constants/IntegrationsList.constants';
// const IntegrationsForUpdater = [IntegrationSources.SLACK, IntegrationSources.JIRA];

export const InputSources: InputDataSourceItemType[] = [
  {
    id: IntegrationSources.SLACK_AI,
    name: 'Slack',
    logo: SlackLogo,
  },
  {
    id: IntegrationSources.JIRA,
    name: 'Jira',
    logo: JiraLogo,
  },
  {
    id: IntegrationSources.ASANA,
    name: 'Asana',
    logo: AsanaLogo,
  },
  {
    id: IntegrationSources.HUBSPOT,
    name: 'Hubspot',
    logo: HubspotLogo,
  },
  {
    id: IntegrationSources.SALEFORCE,
    name: 'Salesforce',
    logo: SalesforceLogo,
  },
];
